import { getFlags } from 'Services/LaunchDarkly';

import AbstractFeatureFlagProvider from './AbstractFeatureFlagProvider';
import { camelize } from '../FeatureFlagService.utils';

type FeatureKeyValue = [name: string, value: unknown];

export default class LaunchDarklyFeatureFlagProvider extends AbstractFeatureFlagProvider {
  constructor(priority: number) {
    super('LAUNCH_DARKLY_FF', priority, true);
  }

  override async getFeatureFlags() {
    const flags = getFlags();
    const setFeature = ([name, value]: FeatureKeyValue) => (
      typeof value !== 'undefined' && this.features.set(camelize(name), value)
    );

    Object.entries(flags).forEach(setFeature);
  }
}
